import { Color } from "src/elements/Color/Color";

/** CDT Studio theme over the shared Color tokens; severity names follow the flag taxonomy. */
export const STUDIO_THEME = {
  surface: Color.lightGray,
  canvasBackground: Color.white,
  border: Color.lightGrayHover,
  text: Color.textMain,
  textSecondary: Color.textSecondary,
  primary: Color.primary,

  severity: {
    blocking: {
      text: Color.alertHighBadgeText,
      background: Color.alertHighBg,
      border: Color.alertHighBorder,
      icon: Color.alertHighIcon,
    },
    toCheck: {
      text: Color.alertMediumBadgeText,
      background: Color.alertMediumBg,
      border: Color.alertMediumBorder,
      icon: Color.alertMediumIcon,
    },
    toReview: {
      text: Color.alertLowBadgeText,
      background: Color.alertLowBg,
      border: Color.alertLowBorder,
      icon: Color.alertLowIcon,
    },
    resolved: {
      text: Color.successText,
      background: Color.successBg,
      border: Color.successBorder,
      icon: Color.successIcon,
    },
  },
} as const;

export type StudioSeverityTheme = keyof typeof STUDIO_THEME.severity;
